import { render, staticRenderFns } from "./MyLib.vue?vue&type=template&id=49f7776a&scoped=true"
import script from "./MyLib.vue?vue&type=script&lang=js"
export * from "./MyLib.vue?vue&type=script&lang=js"
import style0 from "./MyLib.vue?vue&type=style&index=0&id=49f7776a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f7776a",
  null
  
)

export default component.exports